
import { PageMeta } from '../../components/shared/PageMeta';
import { Navigation } from '../../components/feature/Navigation';
import { DemoHeroSection } from './components/DemoHeroSection';
import { DemoVideoSection } from './components/DemoVideoSection';
import { DemoFeaturesSection } from './components/DemoFeaturesSection';
import { DemoTestimonialsSection } from './components/DemoTestimonialsSection';
import { DemoCTASection } from './components/DemoCTASection';
import { FooterSection } from '../../components/feature/FooterSection';
import { MinimalAurora } from '../../components/feature/MinimalAurora';

export default function DemoPage() {
  return (
    <div className="min-h-screen relative bg-black">
      <PageMeta path="/demo" />
      {/* Minimal Aurora Background */}
      <MinimalAurora />
      
      {/* Content */}
      <div className="relative z-10">
        <Navigation />
        <DemoHeroSection />
        <DemoVideoSection />
        <DemoFeaturesSection />
        <DemoTestimonialsSection />
        <DemoCTASection />
        <FooterSection />
      </div>
    </div>
  );
}
